import moment from 'moment';
import { ALTERNATIVE_FUNDS_TEST_ID } from 'ok-mifid/constants/constants';

const isPrivateEquityTest = (testId) => {
    return testId === ALTERNATIVE_FUNDS_TEST_ID;
}

const isPrivateEquityTestExpired = (lastDateTest) => {
    const executionDateAfter6Months = moment(lastDateTest, "DD/MM/YYYY HH:mm:ss").add(6, 'month');
    const today = moment();
    return today.isAfter(executionDateAfter6Months);
}

export { isPrivateEquityTest, isPrivateEquityTestExpired };